import script from "./userManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./userManage.vue?vue&type=script&lang=ts&setup=true"

import "./userManage.vue?vue&type=style&index=0&id=8d777cee&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d777cee"]])

export default __exports__